// The heading of the calculator form card on /navamsa-chart and
// /hi/navamsa-chart. It is indexed page copy, not a control: on /hi/ it stays
// Devanagari, the script the page still ranks for (owner decision 2026-10-08).
// The card's controls are the governed Hinglish in ./_form-copy.ts, which
// tests/hindi-register.test.ts scans whole-file, so the heading lives here.
export const NAVAMSA_FORM_HEADING = {
  en: "Generate Your Navamsa Chart (D9)",
  hi: "अपना नवांश चार्ट (D9) बनाएं",
} as const;
